import { getJSONFromHtml } from '../../../../domain/common';
import { YotpoReview } from '../../../../ui/rating/interfaces';
import ReactDOM from 'react-dom';
import React from 'react';
import StarRating from '../../../../ui/rating/star-rating';

export const initYotpoStars = () => {
    const $yotpoDataWidget = document.getElementById('star-rating-widget-data');
    if(!$yotpoDataWidget) {
        console.error('Yotpo data widget with id="star-rating-widget-data" is missing.');
        return;
    }

    const yotpoReviews = getJSONFromHtml($yotpoDataWidget) as YotpoReview[];
    if(!yotpoReviews?.length) {
        console.error('Yotpo data array is empty.');
        return;
    }

    // In online mastering, there is always
    // only one review.
    const yotpoReview = yotpoReviews[0];

    const $placeholders = document.querySelectorAll('[data-olm-yotpo-stars]');


    for(const $placeholder of $placeholders) {
        ReactDOM.render(
            <React.StrictMode>
                {/*<SvgStarRating
                    rating={ yotpoReview.rating }
                    reviews={ yotpoReview.reviewsTotal }

                    starSize={ 18 }
                    starColor={ '#B393FB' }

                    url={ yotpoReview.documentUrlPath }
                    urlHashHide={ true }
                />*/}
                <StarRating
                    rating={ yotpoReview.rating }
                    reviews={ yotpoReview.reviewsTotal }
                    url={ yotpoReview.documentUrlPath }
                    urlHashHide={ true }
                    colorClass={ 'text-white' }
                    ratingTextClasses={ 'text-2xl line-height-normal font-roboto'}
                    reviewsTextClasses={ 'text-2xl line-height-normal font-roboto olm-comment-opacity'}
                    ratingMarginClasses={ 'mr-2' }
                    reviewsMarginClasses={ 'ml-2' }
                    rviewsTextStyles={ {
                        fontSize: '21px',
                    }}
                />
            </React.StrictMode>,
            $placeholder,
        );
    }
};
